import React from "react";
import { DatePickerPlain } from "./DatePickerPlain";

export const FormikDatePicker = (formikFieldProps: any) => {
  const { field, form, ...props } = formikFieldProps;

  const onChange = (ms?: number | null) => {
    form.setFieldValue(field.name, ms);
  };

  const getFieldValue = () => {
    return field.value;
  };

  return (
    <DatePickerPlain
      value={getFieldValue()}
      onChange={onChange}
      className={props.className}
      placeholder={props.placeholder}
      required={props.required}
    />
  );
};
